module.exports = __webpack_public_path__ + "static/img/2020-10-04 11.42.43.954a7b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2020-10-04 11.42.43.jpg
// module id = LXMu
// module chunks = 4